module.exports = __webpack_public_path__ + "static/media/promotional-graphic.d21303dd.png";